import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

const RedirectToSignup = () => {
  useEffect(() => {
    // Redirect to the external URL
    window.location.replace('https://app.dante-ai.com/sign-up');
  }, []);

  return null;
};

export default RedirectToSignup;
